// Header.js

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faWhatsapp, faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import './styling/Header.css'; // Import your CSS file for styling

const Header = () => {
  return (
    <div className="header">
      <div className="left">
        <div className="follow-us">
          <span> Follow us: </span>
          <div className="social-icons">
            <a href="https://www.facebook.com/arosepowertechnologies"  target="_blank" rel="noopener noreferrer" className="icon" title="Facebook">
              <FontAwesomeIcon icon={faFacebook} />
            </a> 
            <a href="https://wa.me/923332113055"  target="_blank" rel="noopener noreferrer" className="icon" title="Whatsapp">
              <FontAwesomeIcon icon={faWhatsapp} />
            </a>
            <a href="https://www.instagram.com/arosepowertechnologies"  target="_blank" rel="noopener noreferrer" className="icon" title="Instagram">
              <FontAwesomeIcon icon={faInstagram} />
            </a>
            <a href="https://www.linkedin.com/in/arosepowertechnologies"  target="_blank" rel="noopener noreferrer" className="icon" title="LinkedIn">
              <FontAwesomeIcon icon={faLinkedin} />
            </a>
          </div>
        </div>
      </div>
      <div className="center">
      وَمَن يَتَوَكَّلْ عَلَى اللَّهِ فَهُوَ حَسْبُهُ
      <br />
      And whoever relies upon Allah, then He is sufficient for him
      </div>
      <div className="right">
        <a href="#" className="icon" title="Telephone">📞 +92 21 32734269</a>
        <a href="#" className="icon" title="Email">✉️ arosepowertechnologies@outlook.com</a>
      </div>
    </div>
  );
};

export default Header;
